import { render, staticRenderFns } from "./Tab3BaselineGoal.vue?vue&type=template&id=2582a63c&scoped=true"
import script from "./Tab3BaselineGoal.vue?vue&type=script&lang=js"
export * from "./Tab3BaselineGoal.vue?vue&type=script&lang=js"
import style0 from "./Tab3BaselineGoal.vue?vue&type=style&index=0&id=2582a63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2582a63c",
  null
  
)

export default component.exports